// extracted by mini-css-extract-plugin
export default {"background":"our-stores_background__T5W2W","carousel-wrapper":"our-stores_carousel-wrapper__02AZL","all-stores":"our-stores_all-stores__fChQz"};